import React, { useEffect, useState } from "react";
import "./GlobalBar.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/hub`;

const LINKS = [
  { key: "hub", label: "Consulting Hub", href: "/hub" },
  { key: "fire-public", label: "Fire Training", href: "/" },
  { key: "fire-admin", label: "Fire Admin", href: "/admin/dashboard" },
];

function useHubUser() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const load = () => {
      const token = localStorage.getItem("asf_token");
      if (!token) { setUser(false); return; }
      fetch(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` }, credentials: "include" })
        .then((r) => (r.ok ? r.json() : false))
        .then(setUser)
        .catch(() => setUser(false));
    };
    load();
    window.addEventListener("asf-auth", load);
    return () => window.removeEventListener("asf-auth", load);
  }, []);
  return user;
}

async function signOut() {
  const token = localStorage.getItem("asf_token");
  try {
    await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include", headers: token ? { Authorization: `Bearer ${token}` } : {} });
  } catch (e) { /* ignore */ }
  localStorage.removeItem("asf_token");
  window.location.href = "/hub/login";
}

export default function GlobalBar({ section }) {
  const user = useHubUser();
  if (section === "fire-public" && !user) return null;
  return (
    <nav className="gbar" data-testid="global-nav-bar">
      <a href="/hub" className="gbar-brand" data-testid="global-nav-brand">ASF<span>Unified</span></a>
      <div className="gbar-switch" role="tablist">
        {LINKS.map((l) => (
          <a key={l.key} href={l.href} role="tab" aria-selected={section === l.key}
             className={`gbar-tab${section === l.key ? " is-active" : ""}`} data-testid={`global-nav-${l.key}`}>
            {l.label}
          </a>
        ))}
      </div>
      <div className="gbar-user">
        {user ? (
          <>
            <span className="gbar-name" data-testid="global-nav-user-name">{user.name || user.email}</span>
            <button type="button" className="gbar-btn" onClick={signOut} data-testid="global-nav-signout">Sign out</button>
          </>
        ) : user === false ? (
          <a href="/hub/login" className="gbar-btn" data-testid="global-nav-signin">Sign in</a>
        ) : null}
      </div>
    </nav>
  );
}
